import type { Popup, Tooltip } from '@anlan/gs-map';
import { useAttribution } from './attribution';
import { useLeafletContext } from './context';
import { useEventHandlers } from './events';
import { withPane } from './pane';
import type { LeafletContextInterface } from './context';
import type { ElementHook, LeafletElement } from './element';
import type { LayerProps } from './layer';

export type DivOverlay = Popup | Tooltip;
export type SetOpenFunc = (open: boolean) => void;
export type DivOverlayLifecycleHook<E, P> = (element: LeafletElement<E>, context: LeafletContextInterface, props: P, setOpen: SetOpenFunc) => void;
export type DivOverlayHook<E extends DivOverlay, P> = (useElement: ElementHook<E, P>, useLifecycle: DivOverlayLifecycleHook<E, P>) => (props: P, setOpen: SetOpenFunc) => ReturnType<ElementHook<E, P>>;

export function createDivOverlayHook<E extends DivOverlay, P extends LayerProps>(useElement: ElementHook<E, P>, useLifecycle: DivOverlayLifecycleHook<E, P>) {
    return function useDivOverlay(props: P, setOpen: SetOpenFunc) {
        const context = useLeafletContext();
        const elementRef = useElement(withPane(props, context), context);
        useAttribution(context.map, props.attribution);
        useEventHandlers(elementRef.current, props.eventHandlers);
        useLifecycle(elementRef.current, context, props, setOpen);
        return elementRef;
    };
}
